import { render, staticRenderFns } from "./upload-documents.vue?vue&type=template&id=3e0d904c"
import script from "./upload-documents.vue?vue&type=script&lang=js"
export * from "./upload-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports